export function LoginService(
    $http,
    BASE_PATH_API
) {
    const service = this;
    
    service.lookupSubscribersWithToken = function lookupSubscribersWithToken(token, emailAddress, password) {
        const request = {
            method: 'POST',
            url: `${BASE_PATH_API}/subscribers/lookup`,
            headers: {
                Authorization: `Bearer ${token}`
            },
            data: {
                Username: emailAddress,
                Password: password
            }
        };
        
        return $http(request)
            .then(response => response.data);
    };
    
    service.loginSubscriberWithToken = function loginSubscriberWithToken(
        token,
        userName,
        password,
        stateParams,
        accountId,
        reCaptchaToken,
        userId
    ) {
        const request = {
            method: 'POST',
            url: `${BASE_PATH_API}/auth/login`,
            headers: {
                Authorization: `Bearer ${token}`
            },
            data: {
                Username: userName,
                Password: password,
                ReturnUrl: stateParams,
                AccountId: accountId,
                ReCaptchaToken: reCaptchaToken,
                UserId: userId
            }
        };
        
        return $http(request)
            .then(response => response.data);
    };
    
    return service;
}

LoginService.$inject = [
    '$http',
    'BASE_PATH_API'
];
